import axios from 'axios';
import type { z } from 'zod';
import { env } from '@/shared/config/env';
import { getCurrentRole } from '@/shared/session/roleStore';
import { toAppError } from './errors';

export const http = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  timeout: 20_000,
});

http.interceptors.request.use((config) => {
  config.headers.set('X-Demo-Role', getCurrentRole());
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err: unknown) => Promise.reject(toAppError(err)),
);

type RequestOptions = { params?: object; signal?: AbortSignal };

/** GET + Zod validation at the boundary, so a contract change fails here, not three components deep. */
export async function getJson<S extends z.ZodType>(url: string, schema: S, opts: RequestOptions = {}): Promise<z.infer<S>> {
  const res = await http.get<unknown>(url, opts);
  return schema.parse(res.data);
}

export async function sendJson<S extends z.ZodType>(
  method: 'post' | 'patch' | 'delete',
  url: string,
  schema: S,
  body?: unknown,
): Promise<z.infer<S>> {
  const res = await http.request<unknown>({ method, url, data: body });
  return schema.parse(res.data);
}

export const apiUrl = (path: string) => `${env.VITE_API_BASE_URL}${path}`;
